import { timeToLocal } from '@/shared/lib';

import { MarketModel } from './model';

import type {
  MarketTickerViewModelImpl,
  MarketViewModelImpl,
  TradingData,
  UpbitMarketCandleResponse,
  UpbitTickerResponse,
} from '../types';

export class MarketViewModel implements MarketViewModelImpl {
  model: MarketModel[];
  constructor(data: UpbitMarketCandleResponse[]) {
    this.model = data.map(candle => new MarketModel(candle));
  }

  get data() {
    return this.model.map(item => this.#toChart(item));
  }

  get length() {
    return this.model.length;
  }

  get firstDate() {
    return this.model?.[0].kstTime;
  }

  #toChart(data: MarketModel) {
    return {
      time: timeToLocal(new Date(data.kstTime).getTime()),
      open: data.open,
      high: data.high,
      low: data.low,
      close: data.close,
    } as TradingData;
  }

  addData(data: MarketModel[]) {
    this.model = [...data, ...this.model];
  }
}

export class TickerViewModel implements MarketTickerViewModelImpl {
  data: UpbitTickerResponse;
  constructor(data: UpbitTickerResponse) {
    this.data = data;
  }

  get ticker() {
    const d = this.data as Record<string, any>;
    return {
      price: {
        changePrice: d.change_price ?? d.changePrice,
        signedChangePrice: d.signed_change_price ?? d.signedChangePrice,
        signedChangeRate: d.signed_change_rate ?? d.signedChangeRate,
        volume: d.acc_trade_volume ?? d.accTradeVolume,
        volume24h: d.acc_trade_volume_24h ?? d.accTradeVolume24h,
        tradePrice: d.trade_price ?? d.tradePrice,
        openingPrice: d.opening_price ?? d.openingPrice,
        highPrice: d.high_price ?? d.highPrice,
        lowPrice: d.low_price ?? d.lowPrice,
        prevClosingPrice: d.prev_closing_price ?? d.prevClosingPrice,
        accTradePrice24h: d.acc_trade_price_24h ?? d.accTradePrice24h,
        highest52WeekPrice: d.highest_52_week_price ?? d.highest52WeekPrice,
        highest52WeekDate: String(d.highest_52_week_date ?? d.highest52WeekDate ?? ''),
        lowest52WeekPrice: d.lowest_52_week_price ?? d.lowest52WeekPrice,
        lowest52WeekDate: d.lowest_52_week_date ?? d.lowest52WeekDate,
        change: d.change,
      },
    };
  }
}
